const plans = [
  {
    name: "Free",
    price: "0",
    priceoffer: "0",

    monthly_messages: 50,
    links_to_crawl: 10,
    max_chatbots: 1,
  },
  {
    name: "Standard",
    price: "99",
    priceoffer: {
      1: { launchOffer: 25, regular: 99 },
      3: { launchOffer: 49, regular: 249 },
      6: { launchOffer: 139, regular: 449, bestOffer: true },
      12: { launchOffer: 249, regular: 799 },
    },
    monthly_messages: 10000,
    links_to_crawl: 1000,
    max_chatbots: 2,
  },
  {
    name: "Professional",
    price: "399",
    priceoffer: {
      1: { launchOffer: 99, regular: 399 },
      3: { launchOffer: 399, regular: 999 },
      6: { launchOffer: 899, regular: 2499 },
      12: { launchOffer: 1399, regular: 3999 },
    },
    monthly_messages: 40000,
    links_to_crawl: 5000,
    max_chatbots: 5,
  },
];

export default plans;
